// AWS Cognito Configuration
const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_ohLOswurY',
      userPoolClientId: '4m4edj8snokmhqnajhlj41h9n2', // nx-tt-dev-ver3-web-client
      region: 'us-east-1',
      loginWith: {
        email: true,
      },
      signUpVerificationMethod: 'code',
      userAttributes: {
        email: {
          required: true,
        },
      },
      allowGuestAccess: true,
      passwordFormat: {
        minLength: 8,
        requireLowercase: false,
        requireUppercase: false,
        requireNumbers: false,
        requireSpecialCharacters: false,
      },
    },
  },
};

export default awsConfig;
